exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.col-md-3 {\r\n    padding-left: 0px !important;\r\n    padding-bottom: 10px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/modules-functions/modules-functions.component.css
// module id = ../../../../../src/app/_components/modules-functions/modules-functions.component.css
// module chunks = main